import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";

export default function SeoHead() {
    const location = useLocation();
    const { lang } = useParams<{ lang?: string }>();

    // Default URL from environment variable, fallback to https://omahring.id
    const baseUrl = import.meta.env.VITE_APP_URL || "https://omahring.id";

    // Remove trailing slashes and get path without language prefix
    let path = location.pathname.replace(/\/$/, "");
    if (lang && path.startsWith(`/${lang}`)) {
        path = path.slice(lang.length + 1);
    }

    // Ensure path starts with /
    if (!path.startsWith("/")) {
        path = `/${path}`;
    }
    if (path === "/") {
        path = "";
    }

    // Supported languages
    const languages = ["id", "en", "my"];

    // Determine current canonical URL
    const currentLang = languages.includes(lang as string) ? lang : "id";
    const canonicalUrl = `${baseUrl}/${currentLang}${path}`;

    return (
        <Helmet>
            <html lang={currentLang === "my" ? "ms" : currentLang} />
            <link rel="canonical" href={canonicalUrl} />
            {languages.map((l) => (
                <link
                    key={l}
                    rel="alternate"
                    hrefLang={l === "my" ? "ms" : l}
                    href={`${baseUrl}/${l}${path}`}
                />
            ))}
            <link
                rel="alternate"
                hrefLang="x-default"
                href={`${baseUrl}/id${path}`}
            />
        </Helmet>
    );
}
